import firebase from 'firebase'
import 'firebase/firestore'

const config =  
{
    apiKey: "AIzaSyC1Vxu9qogsFvJQNUTX0FnXypwUs31ibjw",
    authDomain: "selbegmn-7e8b1.firebaseapp.com",
    databaseURL: "https://selbegmn-7e8b1.firebaseio.com",
    projectId: "selbegmn-7e8b1",
    storageBucket: "selbegmn-7e8b1.appspot.com",
    messagingSenderId: "968033919359",
    appId: "1:968033919359:web:fb1b5e2c4d3242a0767a4a",
    measurementId: "G-R4LY9768PE"
};
firebase.initializeApp(config)
// firebase utils
const firestore=firebase.firestore
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser
const googleProvider = new firebase.auth.GoogleAuthProvider();
const usersCollection= db.collection("users")
const storage = firebase.storage;
const storageRef = firebase.storage().ref();
const searchUrl= "http://43.231.113.102:8080/selbeg/api/search";
export {
    db,
    auth,
    currentUser,
    googleProvider, 
    usersCollection,
    storage,
    storageRef,
    firestore,
    searchUrl

}